/*global define*/

define("models/App", [
	'jquery',
    'underscore',
    'backbone',
    'collections/Workbench',
    'models/Workbench',
    'views/Workbench'
], function ($, _, Backbone, WorkbenchCollection, WorkbenchModel, WorkbenchView) {
    'use strict';
    var AppModel = Backbone.Model.extend({
        defaults: {
        	workbenches: new WorkbenchCollection(),
        	currentWorkbenchCid: undefined,
            navView: undefined,
            stockroomView: undefined,
            instrumentPanelView: undefined,
        	workbenchViews: {},
            workbenchCount: 1,
            problem: null
        },
        renderCurrentWorkbench: function(){
            var currentWorkbenchCid = this.get('currentWorkbenchCid');
            var currentWorkbenchView = this.get('workbenchViews')[currentWorkbenchCid];
            currentWorkbenchView.render();
        },
        deleteVessel: function(vesselCid){
            var wb = this.get('workbenches').get(this.get('currentWorkbenchCid'));
            wb.deleteVessel(vesselCid);

            this.get('managerView').render();
        },
        getCurrentWorkbenchModel: function(){ return  this.get('workbenches').get(this.get('currentWorkbenchCid'));          },
        getCurrentWorkbenchView: function(){
            var currentWorkbenchCid = this.get('currentWorkbenchCid');
            return this.get('workbenchViews')[currentWorkbenchCid];
        },
        getCurrentVessel: function(){
            var wbs = this.get('workbenches');
            var wbCid = this.get('currentWorkbenchCid');
            var wb = wbs.get(wbCid);

            var vslId = wb.get('currentVesselCid');
            var vsls = wb.get('vessels');
            var vsl = vsls.get(vslId);

            return vsl;
        }
    });
    return AppModel;
});
